import { List, Stack, Text, Title } from '@mantine/core';

export const Applications = () => {
    return (
        <Stack gap="md">
            <Title order={3}>Applications</Title>

            <Text>After signing in, you are redirected to a Panasonic Cloud application. The login application manages which application you are sent to.</Text>

            <Title order={4} td="underline">How Redirection Works</Title>

            <List type="ordered" spacing="sm">
                <List.Item>You sign in with your account</List.Item>
                <List.Item>The system checks which applications you have access to</List.Item>
                <List.Item>You are redirected to your default application</List.Item>
            </List>

            <Title order={4} td="underline">Return To</Title>

            <Text>On the account selection screen, you may see a "Return to" section showing available applications. Click on an application name to be redirected there after signing in.</Text>

            <Title order={4} td="underline">OAuth2 Integration</Title>

            <Text>Some applications redirect you to this login page to authenticate. After signing in, you are automatically sent back to the application that requested authentication. This happens seamlessly — you do not need to take any extra steps.</Text>
        </Stack>
    );
};
